<template>
    <div @click.stop.prevent="handleClick">
        <div class="row">
            <div class="col-12 col-xs-12">
                <h3 class="txt--xl">
                    {{title}}
                </h3>
            </div>
        </div>
        <div class="row" v-if="description != ''">
            <div class="col-12 col-xs-12">
                <p>{{description}}</p>
            </div>
        </div>
        <div class="row" v-if="errorLower || errorUpper">
            <div class="col-12 col-xs-12">
                <p v-if="errorUpper && !errorLower" class="danger-text"><strong>You have indicated that the patient has more than two arms or arm segments amputated.</strong></p>
                <p v-if="errorLower && !errorUpper" class="danger-text"><strong>You have indicated that the patient has more than two legs or leg segments amputated.</strong></p>
                <p v-if="errorLower && errorUpper" class="danger-text"><strong>You have indicated that the patient has more than two arms/ arm segments  or more than two legs/leg segments amputated.</strong></p>
                <br/>
            </div>
        </div>
        <div class="row"  v-for="(part, index) in parts" :key="index">
            <div class="col-6 col-xs-3 col-sm-2 col-md-3 col-lg-2">
                <select v-model="part.answer" :id="'part-' + index" class="calculator__input calculator__input--select" @change="change" @blur="blur">
                    <option v-for="(option, i) in part.options" :selected="option == 0 ? 'selected' : ''" :key="i" :value="option">{{option.text}}</option>
                </select>
            </div>
            <div class="col-6 col-xs-9 col-sm-10 col-md-9 col-lg-10">
                <label class="calculator__label" :for="'part-' + index">{{part.title}}</label>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xs-12">
                <p><a href="https://www.bapen.org.uk/pdfs/must/must_explan.pdf" target="_blank">How score is adjusted for amputees</a> – from BAPEN MUST explanatory booklet.</p>
            </div>
        </div>        
        <hr class="mb-2 mb--2">
    </div>
</template>

<script>

	import dataAmpultations from "@/components/data/ampultations.json";
	export default {
		name: "SelectParts",
        props: {
            title: String,
            description: String,
            errorUpper: Boolean,
            errorLower: Boolean
        },        
		data() {
			return this.initialState();
		},
		methods: {
					
			handleClick(e) {
                if (e.target.matches("a")) {
                    let url = e.target.href;
                    let target = e.target.target == "_blank" ? "_blank" : "_self";
                    let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
                    var isnativeapp = document.getElementById("isnativeapp");
                    if (isnativeapp === undefined || isnativeapp === null) 
                    {
                        window.open(url,target);  
                    }
                    else{
                        if(target == "_blank") {
                            let data = {title:'',nodeid: dataId, href:url, target: target};
                            window.Native('dataCallback', data);
                        } 
                    }	
                }
            },

            initialState() {
                return {
                    parts: dataAmpultations
                };
            },

			reset() {
				Object.assign(this.$data, this.initialState());
                let parts = this.parts;
                for (var i = 0, l = parts.length; i < l; i++) {
                    parts[i].answer = parts[i].options[0];
                }
			},

            change() {                
				this.$emit("change");
            },
            
            blur() {                
				this.$emit("blur");
            }
		}
	};
</script>